import React from "react";
import FileUpload from "@/components/controls/FileUpload/FileUpload";
import { SavedAttachmentInfo } from "@/entities/attachments/types";

interface Props {
  attachments: SavedAttachmentInfo[];
  onAttachmentsChange: (attachments: SavedAttachmentInfo[]) => void;
  disabled?: boolean;
  disabledTooltipText?: string;
}

const Files: React.FC<Props> = ({
  attachments,
  onAttachmentsChange,
  disabled = false,
  disabledTooltipText
}) => {
  return (
    <div className="flex flex-col gap-4">
      <FileUpload
        onAttachmentsChange={(nextAttachments) => {
          // An upload already in flight when the lock lands must not
          // write through its completion callback.
          if (disabled) return;
          onAttachmentsChange(nextAttachments);
        }}
        initialAttachments={attachments}
        // Any file type, same as a file field set to "Any file type".
        accept=""
        isReadOnly={false}
        disabled={disabled}
        disabledTooltipText={disabledTooltipText}
      />
    </div>
  );
};

export default Files;
